export enum LocalStorageKey {
  AuthInfo = "AUTH_INFO",
  PendingRedirectPath = "PENDING_REDIRECT_PATH",
}
